import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-login-phone-validation',
  templateUrl: './phone-validation.component.html',
  styleUrls: ['../login.component.css', './phone-validation.component.css'],
  standalone: false,
})
export class PhoneValidationComponent {
  // Context bridge to parent login component
  @Input() ctx: any;
  @Input() loading = false;

  constructor(public theme: ThemeService) {}
}
